import { createNumberFormatter } from '@dreryk/react-common';

import { getTimesOfDaySchema as getSharedTimesOfDaySchema, TimesOfDayDosageCycle } from '~libs.shared.prescription';

const PORTION_FRACTION_DIGITS = 5;

const portionFormatter = createNumberFormatter({ maximumFractionDigits: PORTION_FRACTION_DIGITS });

export const getFormattedPortion = (portion: number): string => portionFormatter(Number(portion)) ?? '';

export const getTimesOfDaySchema = (cycle: TimesOfDayDosageCycle): string =>
   getSharedTimesOfDaySchema(cycle, getFormattedPortion);
